export default __webpack_public_path__ + "static/media/aston-martin.74d7b911.svg";